import {
  // getReq,
  postReq,
  // deleteSendReq,
  // putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  exportExcelReq,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  emptySearchInfo: {
    searchType: 'MONTH', // ALL, MONTH, DT_SCOPE
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'CURRENT', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date()),
    searchCtrAcctId: '',
    searchFundStatEntityIdList: [],
    searchFundStatEntityList: [],
    searchEntityId: '',
    paymentId: ''
  },
  searchInfo: {
    searchType: 'MONTH', // ALL, MONTH, DT_SCOPE
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'CURRENT', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date()),
    searchCtrAcctId: '',
    searchFundStatEntityIdList: [],
    searchFundStatEntityList: [],
    paymentId: ''
  },
  searchedForm: {},
  transList: [],
  END_STATE: null
}

const getters = {

}

const actions = {
  async findTransListByPayment({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
  // }, { fundStatEntityList, searchCtrAcctId, searchMonth, projId, compId, searchType, startDt, endDt }) {
    let searchedForm = state.searchedForm || state.emptySearchInfo
    let data = {
      projId,
      compId,
      fundStatEntityList: searchedForm.searchFundStatEntityList,
      ctrAcctId: searchedForm.searchCtrAcctId,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime()
    }
    const response = await postReq(END_POINTS.FIND_TRANS_LIST_BY_PAYMENT, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateTransList', response)
  },
  async downloadTransListByPayment({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    let searchedForm = state.searchedForm || state.emptySearchInfo
    // console.log('emptySearchInfo:', state.emptySearchInfo)
    // console.log('searchedForm:', searchedForm)
    // debugger
    let data = {
      projId,
      compId,
      fundStatEntityList: searchedForm.searchFundStatEntityList,
      ctrAcctId: searchedForm.searchCtrAcctId,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime()
    }
    const response = await exportExcelReq(END_POINTS.DOWNLOAD_TRANS_LIST_BY_PAYMENT, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    // console.log('exportExcelReq.resp:', response)
    return response
  },

  END_ACTIONS() {}
}

const mutations = {
  async updateSearchedForm(state) {
    state.searchedForm = {...state.searchInfo}
  },
  // async updateSearchInfo(state, searchInfo) {
  //   state.searchInfo = {...searchInfo}
  // },
  async resetSearchInfo(state) {
    state.searchInfo = {...state.emptySearchInfo}
  },
  updateSearchType(state, value) {
    state.searchInfo.searchType = value
  },
  updateSearchMonth(state, value) {
    state.searchInfo.searchMonth = value
  },
  updateSearchMonthType(state, value) {
    state.searchInfo.searchMonthType = value
  },
  // updateSearchDtScope(state, value) {
  //   state.searchInfo.searchDtScope = value
  // },
  updateSearchStartDt(state, value) {
    state.searchInfo.searchStartDt = value
  },
  updateSearchEndDt(state, value) {
    state.searchInfo.searchEndDt = value
  },
  updateSearchCtrAcctId(state, value) {
    state.searchInfo.searchCtrAcctId = value
  },
  updateSearchFundStatEntityIdList(state, value) {
    state.searchInfo.searchFundStatEntityIdList = value
  },
  updateSearchFundStatEntityList(state, value) {
    state.searchInfo.searchFundStatEntityList = value
  },
  updateSearchPaymentId(state, value) {
    state.searchInfo.paymentId = value
  },
  updateSearchFundStatEntityIdListEmpty(state, value) {
    state.searchInfo.searchFundStatEntityIdList = []
  },
  updateSearchFundStatEntityIdListAdd(state, value) {
    state.searchInfo.searchFundStatEntityIdList.push(value)
  },
  //
  updateTransList(state, response) {
    if (response.success === true && response.data.length) {
      state.transList = response.data
      // state.transList = []
    } else {
      state.transList = []
    }
  },
  updateTransListEmpty(state) {
    state.transList = []
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/accountantFlowTransManage.js